module.exports = __webpack_public_path__ + "static/media/santa.34e59de7.gif";